import React, { useEffect, useRef, useState } from "react";
import "./Customer.scss";

import { IoSearch } from "react-icons/io5";
import { FaChevronRight, FaPlus, FaSquareCheck } from "react-icons/fa6";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import { FiDownload } from "react-icons/fi";

import {
  deleteCustomer,
  deleteMultipleCustomers,
  fetchCustomersByOrganization,
} from "../../api/customers";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader/Loader";
import { Link, useLocation, useNavigate } from "react-router-dom";

import ROUTES from "../../constants/routes";
import CustomButton from "../../components/CustomButton/CustomButton";
import {
  clearPaymentCustomerDetails,
  updatePaymentCustomerDetails,
} from "../../redux/features/cart-slice";
import { toast } from "react-toastify";
import { insertCustomerToSale } from "../../api/sales";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import {
  fetchCustomerData,
  updateNetworkStatus,
} from "../../redux/features/home-slice";

import AddCustomer from "./AddCustomer/AddCustomer";

import Papa from "papaparse";
import { useViewPortDetector } from "../../helpers/viewPortDetector";
import { MdAddBox } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import useUserIsAllowed from "../../helpers/userAuthorized";
import {
  deleteExistingCustomer,
  loadCustomersIfNeeded,
  loadNextCustomers,
} from "../../redux/features/customers-slice";
import { storage } from "../../helpers/storage";
import { updateExistingSale } from "../../redux/features/sales-slice";
import SyncLoader from "../../components/SyncLoader/SyncLoader";
import useOrganizationIsAllowed from "../../helpers/organizationPrevillages";
import { updateOpenSubscriptionAd } from "../../redux/features/subscription-slice";
import { LuSearchX } from "react-icons/lu";

const Customer = ({
  isPayment,
  isSale,
  desktopView,
  sale,
  setSelectedDesktopTag,
  setSelectedSale,
}) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();

  const { currentViewPort } = useViewPortDetector();

  const { customer_id } = useSelector((state) => state.cartReducer.value);

  const { id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );

  const {
    customers,
    loading,
    loadingNextPage,
    currentPage,
    lastPage,
    lastParams,
    loadingBackground,
    loadBackgroundFailed,
  } = useSelector((state) => state.customerReducer.value);

  const salesDetails = isSale ? location.state?.salesDetails || sale : null;
  const userDetails = isSale ? location.state?.userData : null;
  const customerData = isSale ? location.state?.customerData : null;
  const searchKeyword = location.state?.searchKeyword || "";
  const customerSelected = location.state?.customerSelected || null;

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [keyword, setKeyword] = useState(searchKeyword);
  const [debounceKeyword, setDebounceKeyword] = useState(searchKeyword);

  const [openDelete, setOpenDelete] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [openImport, setOpenImport] = useState(false);

  const [selectedDesktopPageTag, setSelectedDesktopPageTag] =
    useState("Add Customer");

  const [allowMultipleSelect, setAllowMultipleSelect] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedArray, setSelectedArray] = useState([]);
  const [openMultiDelete, setOpenMultiDelete] = useState(false);

  const [loadingCustomerAdd, setLoadingCustomerAdd] = useState(false);

  const [pageNumber, setPageNumber] = useState(1);
  const lastItemRef = useRef(null);
  const timerRef = useRef(null);

  const userIsAllowedToAddEditCustomer = useUserIsAllowed(
    "create_or_edit_customers"
  );
  const userIsAdministrator = useUserIsAllowed("administrator");
  const userIsAllowedToManageInventory = useUserIsAllowed("manage_inventory");

  const userIsAllowedToDeleteCustomer =
    userIsAdministrator || userIsAllowedToManageInventory;

  useEffect(() => {
    if (customers?.length === selectedArray?.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }

    if (allowMultipleSelect && selectedArray?.length < 1) {
      setTimeout(() => {
        setAllowMultipleSelect(false);
      }, 300);
    }

    if (allowMultipleSelect) {
      setSelectedCustomer(null);
    }
  }, [customers, selectedArray, allowMultipleSelect]);

  const [customerNotFound, setCustomerNotFound] = useState(null);

  useEffect(() => {
    if (debounceKeyword && customers?.length < 1) {
      setCustomerNotFound(`No customer found for ${debounceKeyword}.`);
    }
  }, [customers, debounceKeyword]);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedArray([]);
    } else {
      const tempArray = [];

      customers?.forEach((item) => {
        tempArray.push(item?.id);
      });

      setSelectedArray(tempArray);
    }
  };

  const addCustomerToPayment = (item) => {
    const phonesData = `${item?.phone_number}`.split(" ");

    const userData = {
      customer_name: item.name,
      customer_number: phonesData?.length > 1 ? phonesData[1] : "",
      customer_country_code: phonesData?.length > 1 ? phonesData[0] : "",
      customer_id: item.id,
      customer_address: item.address_line,
      customer_allow_pay_later: item.pay_later,
      customer_credit_amount: Number(item.current_balance).toFixed(2),
    };
    dispatch(updatePaymentCustomerDetails(userData));
    navigate(ROUTES.payment.path);
    toast.dismiss();
    toast.success(`${userData.customer_name} is added to the sale's details.`);
  };

  const addCustomerToSale = (item) => {
    if (salesDetails && salesDetails?.id && item.id) {
      setLoadingCustomerAdd(true);
      const data = {
        customer_id: item.id,
      };
      insertCustomerToSale(salesDetails?.id, data)
        .then((res) => {
          toast.dismiss();
          toast.success("Customer added to sales successfully.");
          if (desktopView) {
            setSelectedDesktopTag && setSelectedDesktopTag("Sales Details");
            setSelectedSale &&
              setSelectedSale({
                ...sale,
                customer: res.data?.sale?.customer || null,
              });
            dispatch(
              updateExistingSale({
                sale: { ...sale, customer: res.data?.sale?.customer || null },
              })
            );
          } else {
            navigate(ROUTES.salesDetails.path, {
              state: {
                item: res.data?.sale,
                userData: userDetails,
                customerData: customerData,
              },
            });
          }
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss();
              toast.error(
                "You do not have sufficient permissions to perform this action. Please contact your administrator."
              );
            } else {
              toast.dismiss();
              toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss();
            toast.error("Error while adding customer to sales!");
          }
        })
        .finally(() => {
          setLoadingCustomerAdd(false);
        });
    }
  };

  const handleDeleteCustomer = () => {
    if (selectedCustomer && selectedCustomer?.id) {
      setDeleting(true);
      deleteCustomer(selectedCustomer?.id)
        .then((res) => {
          toast.dismiss();
          toast.success("Customer deleted successfully.");
          setOpenDelete(false);
          setSelectedCustomer(null);
          dispatch(deleteExistingCustomer({ customer: selectedCustomer }));
          dispatch(fetchCustomerData({ organization_id: organization_id }));
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss();
              toast.error(
                "You do not have sufficient permissions to perform this action. Please contact your administrator."
              );
            } else {
              toast.dismiss();
              toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss();
            toast.error("Error while deleting customer!");
          }
        })
        .finally(() => {
          setDeleting(false);
        });
    } else {
      toast.dismiss();
      toast.error("Customer not selected!");
    }
  };

  const handleClearCustomer = () => {
    dispatch(clearPaymentCustomerDetails());
    toast.dismiss();
    toast.success("Customer data removed.");
    navigate(ROUTES.payment.path);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (
          entry.isIntersecting &&
          pageNumber < lastPage &&
          !loadingNextPage &&
          !loading
        ) {
          setPageNumber((prevPage) => prevPage + 1);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      }
    );

    const currentRef = lastItemRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [
    pageNumber,
    lastPage,
    loadingNextPage,
    loading,
    lastItemRef.current,
    customers,
    selectedArray,
    debounceKeyword,
  ]);

  // Trigger initial fetch and subsequent fetches
  useEffect(() => {
    dispatch(
      loadCustomersIfNeeded({ organization_id, keyword: debounceKeyword })
    );
    setPageNumber(1);
    if (customerSelected) {
      setSelectedCustomer(customerSelected);
    } else {
      setSelectedCustomer(null);
      setSelectedDesktopPageTag("Add Customer");
    }
  }, [organization_id, debounceKeyword]);

  // Handle pagination
  useEffect(() => {
    if (lastPage > currentPage && pageNumber > currentPage) {
      dispatch(loadNextCustomers({ page: pageNumber }));
    }
  }, [pageNumber]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceKeyword(keyword);
    }, 500);

    return () => clearTimeout(handler);
  }, [keyword]);

  const handleSelectItem = (item) => {
    const exists = selectedArray?.findIndex((el) => el === item?.id);

    if (exists === -1) {
      setSelectedArray((pre) => [...pre, item?.id]);
    } else {
      const tempArray = [...selectedArray];
      tempArray.splice(exists, 1);
      setSelectedArray(tempArray);
    }
  };

  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = (e) => {
    const currentScrollTop = e.target.scrollTop;

    if (currentScrollTop !== lastScrollY) {
      handleMouseUp();
    }

    setLastScrollY(currentScrollTop);
  };

  const handleMouseDown = (item, touch) => {
    if (allowMultipleSelect) {
      if (!touch) {
        handleSelectItem(item);
      }
    } else {
      timerRef.current = setTimeout(() => {
        handleSelectItem(item);
        setAllowMultipleSelect(true);
      }, 500);
    }
  };

  const handleMouseUp = () => {
    clearTimeout(timerRef.current);
  };

  useEffect(() => {
    if (loadingBackground) {
      dispatch(updateNetworkStatus({ status: "syncing" }));
    }
  }, [loadingBackground]);
  return (
    <>
      {(loading || loadingCustomerAdd) && <Loader />}
      <div className="page-with-side-components">
        <div className="customer-page">
          {!desktopView && (
            <div className="desktop-navbar box-shadow">
              <p>{ROUTES.customers.title}</p>
              <div className="last-tag-svg">
                <FiDownload
                  onClick={() => {
                    if (userIsAllowedToAddEditCustomer) {
                      setOpenImport((pre) => !pre);
                    } else {
                      toast.dismiss();
                      toast.info(
                        "You do not have sufficient permissions to perform this action. Please contact your administrator."
                      );
                    }
                  }}
                />
              </div>
            </div>
          )}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setDebounceKeyword(e.target.keyword.value);
            }}
            className="customer-search"
          >
            <div className="inputs">
              <input
                type="text"
                name="keyword"
                placeholder="Search by name or number."
                defaultValue={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
              />
              <button type="submit">
                <IoSearch />
              </button>
            </div>
          </form>
          {!isPayment && !isSale && allowMultipleSelect && (
            <div className="multiple-selection">
              <div
                className={`left ${allowMultipleSelect ? "active" : ""}`}
                onClick={() => {
                  setAllowMultipleSelect((pre) => !pre);
                  setSelectedArray([]);
                  setSelectedCustomer(null);
                }}
              >
                <span>
                  <FaSquareCheck />
                </span>
                <p>Multiple Select</p>
              </div>

              <div
                className={`right ${allowMultipleSelect ? "show" : ""} ${
                  selectAll ? "active" : ""
                }`}
                onClick={handleSelectAll}
              >
                <span>
                  <FaSquareCheck />
                </span>
                <p>Select All</p>
              </div>
            </div>
          )}
          <div
            className={`customer-lists container-wrapper ${
              customers?.length > 0 ? "grid" : ""
            }`}
            onScroll={handleScroll}
          >
            {customers?.map((item, i) => {
              const selected = isPayment && customer_id === item?.id;
              const exists = selectedArray?.find((el) => el === item?.id);
              const isMultiSelected = exists ? true : false;
              if (customers?.length - 1 === i) {
                return (
                  <div
                    ref={lastItemRef}
                    style={{ width: "100%" }}
                    key={i}
                    onMouseDown={() => {
                      handleMouseDown(item);
                    }}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseUp}
                    onTouchStart={() => {
                      handleMouseDown(item, true);
                    }}
                    onTouchEnd={handleMouseUp}
                    onTouchCancel={handleMouseUp}
                  >
                    <div
                      className={`item ${selected ? "active" : ""} ${
                        selectedCustomer?.id === item?.id
                          ? "highlight-selected-item"
                          : ""
                      }`}
                      onClick={() => {
                        if (allowMultipleSelect) {
                        } else {
                          if (isPayment) {
                            if (selected) {
                              handleClearCustomer();
                            } else {
                              addCustomerToPayment(item);
                            }
                          } else if (isSale) {
                            addCustomerToSale(item);
                          } else {
                            setSelectedCustomer(item);
                            setSelectedDesktopPageTag("Add Customer");
                          }
                        }
                      }}
                    >
                      <div className="left">
                        <p className="name">{item?.name}</p>
                        <p className="phone">
                          {item?.phone_number}{" "}
                          {item?.email ? `(${item?.email})` : ""}
                        </p>
                        {selected && (
                          <IoIosCheckmarkCircle className="selected-check" />
                        )}
                        {isMultiSelected && (
                          <FaCheckCircle className="selected-check" />
                        )}
                      </div>

                      <FaChevronRight />
                    </div>
                  </div>
                );
              } else {
                return (
                  <div
                    className={`item ${selected ? "active" : ""} ${
                      selectedCustomer?.id === item?.id
                        ? "highlight-selected-item"
                        : ""
                    }`}
                    key={i}
                    onMouseDown={() => {
                      handleMouseDown(item);
                    }}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseUp}
                    onTouchStart={() => {
                      handleMouseDown(item, true);
                    }}
                    onTouchEnd={handleMouseUp}
                    onTouchCancel={handleMouseUp}
                    onClick={() => {
                      if (allowMultipleSelect) {
                      } else {
                        if (isPayment) {
                          if (selected) {
                            handleClearCustomer();
                          } else {
                            addCustomerToPayment(item);
                          }
                        } else if (isSale) {
                          addCustomerToSale(item);
                        } else {
                          setSelectedCustomer(item);
                          setSelectedDesktopPageTag("Add Customer");
                        }
                      }
                    }}
                  >
                    <div className="left">
                      <p className="name">{item?.name}</p>
                      <p className="phone">
                        {item?.phone_number}{" "}
                        {item?.email ? `(${item?.email})` : ""}
                      </p>
                      {selected && (
                        <IoIosCheckmarkCircle className="selected-check" />
                      )}
                      {isMultiSelected && (
                        <FaCheckCircle className="selected-check" />
                      )}
                    </div>

                    <FaChevronRight />
                  </div>
                );
              }
            })}
            {loadingNextPage && (
              <div className="loading-customer">
                <div className="left">
                  <div className="name"></div>
                  <div className="number"></div>
                </div>

                <div className="icon"></div>
              </div>
            )}
            {customers?.length === 0 && (
              <div className="no-item">
                <Link className="mobile" to={ROUTES.addCustomer.path}>
                  {customerNotFound ? <LuSearchX /> : <MdAddBox />}
                </Link>
                <Link
                  className="desktop"
                  to={"#"}
                  onClick={() => {
                    setSelectedDesktopPageTag("Add Customer");
                  }}
                >
                  {customerNotFound ? <LuSearchX /> : <MdAddBox />}
                </Link>
                <p>
                  {customerNotFound
                    ? customerNotFound
                    : "Hey! Let's add your first customer!"}
                </p>
              </div>
            )}
          </div>
          <CustomerOptions
            selectedCustomer={selectedCustomer}
            setSelectedCustomer={setSelectedCustomer}
            setOpenDelete={setOpenDelete}
            openDelete={openDelete}
            setSelectedDesktopPageTag={setSelectedDesktopPageTag}
            selectedDesktopPageTag={selectedDesktopPageTag}
          />
          <DeleteMultipleModel
            open={openMultiDelete}
            setOpen={setOpenMultiDelete}
            selectedList={selectedArray}
            setSelectedList={setSelectedArray}
            organizationId={organization_id}
          />
          {!desktopView && selectedArray?.length === 0 && (
            <Link
              to={
                isPayment
                  ? ROUTES.paymentAddCustomer.path
                  : isSale
                  ? ROUTES.saleAddCustomer.path
                  : currentViewPort === "mobile"
                  ? ROUTES.addCustomer.path
                  : "#"
              }
              state={
                isSale
                  ? {
                      salesDetails: salesDetails,
                      userData: userDetails,
                      customerData: customerData,
                    }
                  : null
              }
              onClick={() => {
                if (currentViewPort === "desktop") {
                  setSelectedDesktopPageTag("Add Customer");
                  setSelectedCustomer(null);
                }
              }}
              className="floating-add-button"
            >
              <FaPlus />
            </Link>
          )}
          {((selectedCustomer && selectedDesktopPageTag !== "Edit Customer") ||
            openMultiDelete) && (
            <div
              className="blur-back"
              onClick={() => {
                setSelectedCustomer(null);
              }}
            ></div>
          )}
          {isSale && (
            <div
              className="navigation-back-button"
              onClick={() => {
                navigate(ROUTES.salesDetails.path, {
                  state: { item: salesDetails },
                });
              }}
            >
              <IoIosArrowBack />
            </div>
          )}
          <ImportField isOpen={openImport} setIsOpen={setOpenImport} />
          {!isPayment && !isSale && (
            <div className="open-import-model">
              <FiDownload
                onClick={() => {
                  if (userIsAllowedToAddEditCustomer) {
                    setOpenImport((pre) => !pre);
                  } else {
                    toast.dismiss();
                    toast.info(
                      "You do not have sufficient permissions to perform this action. Please contact your administrator."
                    );
                  }
                }}
              />
            </div>
          )}
          <DeleteModal
            name={"Customer"}
            deleting={deleting}
            open={openDelete}
            setOpen={setOpenDelete}
            handleDelete={handleDeleteCustomer}
          />
          {selectedArray?.length > 0 && (
            <div className="floating-button">
              <CustomButton
                name={`Delete ${selectedArray?.length} Items`}
                type={"button"}
                color={"danger"}
                bigButton={true}
                handleSubmit={() => {
                  if (userIsAllowedToDeleteCustomer) {
                    setOpenMultiDelete(true);
                  } else {
                    toast.dismiss();
                    toast.info(
                      "You do not have sufficient permissions to perform this action. Please contact your administrator."
                    );
                  }
                }}
                disabled={selectedArray?.length === 0}
              />
            </div>
          )}
        </div>

        {!desktopView && (
          <div className="right-desktop-view">
            <div className="desktop-navbar border-bottom box-shadow">
              {selectedDesktopPageTag === "Edit Customer" && (
                <div
                  className="back"
                  onClick={() => {
                    setSelectedDesktopPageTag("Add Customer");
                  }}
                >
                  <IoIosArrowBack />
                </div>
              )}
              <p>{selectedDesktopPageTag}</p>
            </div>

            {selectedDesktopPageTag === "Add Customer" && (
              <AddCustomer desktopView={true} reload={(data) => {}} />
            )}
            {selectedDesktopPageTag === "Edit Customer" && (
              <AddCustomer
                isEdit={true}
                selected={selectedCustomer}
                desktopView={true}
                reload={(data) => {}}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Customer;

const CustomerOptions = ({
  selectedCustomer,
  setSelectedCustomer,
  setOpenDelete,
  openDelete,
  setSelectedDesktopPageTag,
  selectedDesktopPageTag,
}) => {
  const { currentViewPort } = useViewPortDetector();
  const userIsAllowedToAddEditCustomer = useUserIsAllowed(
    "create_or_edit_customers"
  );

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (
      selectedCustomer &&
      (currentViewPort === "mobile" ||
        selectedDesktopPageTag !== "Edit Customer")
    ) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [selectedCustomer, currentViewPort, selectedDesktopPageTag, isVisible]);

  if (!shouldRender) return null;
  return (
    <div
      className={`customer-options ${isVisible ? "active" : ""}`}
      style={openDelete ? { zIndex: 1 } : {}}
    >
      <p className="heading">Customer Options</p>
      <Link
        to={
          currentViewPort === "mobile" && userIsAllowedToAddEditCustomer
            ? ROUTES.editCustomer.path
            : "#"
        }
        state={
          currentViewPort === "mobile" && userIsAllowedToAddEditCustomer
            ? { editData: selectedCustomer }
            : {}
        }
        onClick={() => {
          if (userIsAllowedToAddEditCustomer) {
            if (currentViewPort === "desktop") {
              setSelectedDesktopPageTag("Edit Customer");
            }
          } else {
            toast.dismiss();
            toast.info(
              "You do not have sufficient permissions to perform this action. Please contact your administrator."
            );
          }
        }}
      >
        <p>Edit Customer</p> <FaChevronRight />
      </Link>
      <Link
        to={ROUTES.customerDetails.path}
        state={{
          customerData: selectedCustomer,
        }}
      >
        <p>Customer Details</p> <FaChevronRight />
      </Link>
      <Link
        to={
          currentViewPort === "mobile"
            ? ROUTES.customerStoreCredit.path
            : ROUTES.customerDetails.path
        }
        state={{
          customerData: selectedCustomer,
        }}
      >
        <p>Store Credit Details</p> <FaChevronRight />
      </Link>

      <div className="buttons">
        <CustomButton
          name={"Delete"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            if (userIsAllowedToAddEditCustomer) {
              setOpenDelete(true);
            } else {
              toast.dismiss();
              toast.info(
                "You do not have sufficient permissions to perform this action. Please contact your administrator."
              );
            }
          }}
        />
        <CustomButton
          name={"Cancel"}
          color={"gray"}
          type={"button"}
          handleSubmit={() => {
            setSelectedCustomer(null);
          }}
        />
      </div>
    </div>
  );
};

const ImportField = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const fileRef = useRef();
  const [file, setFile] = useState("");

  const handleFileChange = (e) => {
    const fileData = e.target.files[0];
    if (fileData) {
      setFile(fileData);
    }
  };

  useEffect(() => {
    if (file) {
      Papa.parse(file, {
        header: false,
        complete: async (results) => {
          const customers = results?.data;
          navigate(ROUTES.customersImport.path, {
            state: {
              csvData: customers,
            },
          });
        },
        skipEmptyLines: true,
      });
    } else {
      if (fileRef) {
        fileRef.current.value = "";
      }
    }
  }, [file]);

  const handleCancel = () => {
    if (fileRef) {
      fileRef.current.value = "";
    }
    setIsOpen(false);
    setFile(null);
  };

  return (
    <div className={`upload-customer-import ${isOpen ? "active" : ""}`}>
      <div className="inputs">
        <input
          ref={fileRef}
          type="file"
          onChange={handleFileChange}
          accept=".csv"
        />
        <FiDownload />
        <p>{file ? "File selected" : "Choose your files"}</p>
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel Import"}
          color={"danger"}
          type={"button"}
          handleSubmit={handleCancel}
          disabled={false}
        />

        <CustomButton
          name={"Import CSV"}
          color={"primary"}
          type={"button"}
          handleSubmit={() => {}}
          disabled={!file}
        />
      </div>
    </div>
  );
};

const DeleteMultipleModel = ({
  open,
  setOpen,
  selectedList,
  setSelectedList,
  organizationId,
}) => {
  const [deleting, setDeleting] = useState(false);
  const dispatch = useDispatch();

  const orgIsAllowedToBulkDelete = useOrganizationIsAllowed("bulk_delete");

  const handleDelete = () => {
    if (orgIsAllowedToBulkDelete.exists) {
      setDeleting(true);

      const data = {
        customers: selectedList,
        organization_id: organizationId,
      };

      deleteMultipleCustomers(data)
        .then((res) => {
          dispatch(fetchCustomerData({ organization_id: organizationId }));
          toast.dismiss();
          toast.success("Customers deleted successfully.");
          setOpen(false);
          setSelectedList([]);
          selectedList?.forEach((el) => {
            dispatch(deleteExistingCustomer({ customer: { id: el } }));
          });
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss();
              toast.error(
                "You do not have sufficient permissions to perform this action. Please contact your administrator."
              );
            } else {
              toast.dismiss();
              toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss();
            toast.error("Error while deleting customers.");
          }
        })
        .finally(() => {
          setDeleting(false);
        });
    } else {
      dispatch(updateOpenSubscriptionAd({ openAd: true }));
    }
  };

  useEffect(() => {
    if (open) {
      if (selectedList?.length === 0) {
        setOpen(false);
      }
    }
  }, [selectedList, open]);

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`confirm-delete-model ${isVisible ? "active" : ""}`}>
      <p className="title">Multiple Customers Delete Confirmation</p>

      <div className="confirm-container">
        <img src="/images/warning.svg" alt="" aria-label="Warning Image" />
        <p>
          Are you sure you want to <span>DELETE</span> these selected customers?{" "}
          <br /> Once deleted, these customers and its related data cannot be
          recovered back.
        </p>
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={deleting}
        />

        <CustomButton
          name={"Yes, Delete"}
          color={"primary"}
          type={"button"}
          handleSubmit={handleDelete}
          disabled={deleting}
          loader={deleting}
        />
      </div>
    </div>
  );
};
